import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Helmet } from 'react-helmet';

import moment from 'moment';

import { isDirty, hasSubmitSucceeded, getFormValues, getFormSyncErrors } from 'redux-form';

import { withStyles } from '@material-ui/core/styles';
import Toolbar from '@material-ui/core/Toolbar';

import Layout from 'components/common/Layout';
import Progress from 'components/common/Progress';
import Prompt from 'components/common/Prompt';
import ReportsCreateEditForm from 'components/reports/ReportsCreateEditForm';
import Button from 'components/common/Button';
import TabNavigation from 'components/common/TabNavigation';

import { appTitle, titleSeparator } from 'config/helmetSettings';
import dateFormat from 'config/dateFormat';

import {
  fetchReport,
  generateReport,
  generateClaimReport,
  generateInsuranceReport,
} from 'redux/modules/reports';

const styles = () => ({
  toolbar: {
    marginBottom: 16,
  },
});

class ReportCreateEdit extends Component {
  constructor(props) {
    super(props);

    this.onReportGenerate = this.onReportGenerate.bind(this);
  }

  componentDidMount() {
    const { variant, actions, match, location } = this.props;
    if (variant === 'edit') {
      actions.fetchReport({
        triggerLoading: !(location.state
          && location.state.justCreated
          && location.state.justCreated === true),
        ID: match.params.id,
      });
    }
  }

  componentWillReceiveProps(nextProps) {
    const { variant, loading, history, initialValues } = this.props;
    if (variant === 'edit') {
      if ((loading > 0
        && nextProps.loading === 0
        && !nextProps.initialValues)
        || (initialValues && !nextProps.initialValues)) {
        history.replace('/reports/custom/create');
      }
    }
  }

  onReportGenerate() {
    const { initialValues, filters, actions, variant, dirty } = this.props;
    let payload = {};
    switch (variant) {
      case 'claim':
        payload.fileName = 'ClaimReport';
        payload.filters = [];
        if (Object.keys(filters).length > 0) {
          if (filters['Patient ID'] && filters['Patient ID'].length > 0) {
            payload.filters = [
              ...payload.filters,
              {
                name: 'Patient ID',
                operation: 'in',
                val: filters['Patient ID'],
              },
            ];
          }
          if (filters['Prescriber ID'] && filters['Prescriber ID'].length > 0) {
            payload.filters = [
              ...payload.filters,
              {
                name: 'Prescriber ID',
                operation: 'in',
                val: filters['Prescriber ID'],
              },
            ];
          }
          if (filters['Sales Representative ID'] && filters['Sales Representative ID'].length > 0) {
            payload.filters = [
              ...payload.filters,
              {
                name: 'Sales Representative ID',
                operation: 'in',
                val: filters['Sales Representative ID'],
              },
            ];
          }
          if (filters['Referral Source ID'] && filters['Referral Source ID'].length > 0) {
            payload.filters = [
              ...payload.filters,
              {
                name: 'Referral Source ID',
                operation: 'in',
                val: filters['Referral Source ID'],
              },
            ];
          }
          if (filters['Claim Date of Creation From'] && filters['Claim Date of Creation To']) {
            payload.filters = [
              ...payload.filters,
              {
                name: 'Date of Creation',
                operation: 'ge',
                val: filters['Claim Date of Creation From'],
              },
              {
                name: 'Date of Creation',
                operation: 'le',
                val: filters['Claim Date of Creation To'],
              },
            ];
          }
          if (filters['Step Number'] && filters['Step Value']) {
            payload.filters = [
              ...payload.filters,
              {
                name: 'Date of Creation',
                operation: 'ge',
                val: moment()
                  .subtract(filters['Step Number'], filters['Step Value'].toLowerCase())
                  .format(dateFormat),
              },
              {
                name: 'Date of Creation',
                operation: 'le',
                val: moment().format(dateFormat),
              },
            ];
          }
        } else {
          payload.filters = [
            ...payload.filters,
            {
              name: 'Date of Creation',
              operation: 'ge',
              val: moment().subtract(1, 'day').format(dateFormat),
            },
            {
              name: 'Date of Creation',
              operation: 'le',
              val: moment().format(dateFormat),
            },
          ];
        }
        actions.generateClaimReport(payload);
        break;
      case 'insurance':
        payload.fileName = 'InsuranceReport';
        actions.generateInsuranceReport(payload);
        break;
      default:
        if (initialValues && !dirty) {
          payload.ID = initialValues.ID;
          payload.fileName = initialValues.Name;
          if (initialValues['Default Report Structure ID']) {
            payload['Report Structure ID'] = initialValues['Default Report Structure ID'];
          }
        } else {
          payload = filters ? { ...Object.assign({}, filters) } : {};
          payload.fileName = initialValues ? initialValues.Name : 'Report';
        }
        actions.generateReport(payload);
    }
  }

  render() {
    const {
      form,
      variant,
      history,
      initialValues,
      dirty,
      loading,
      submitSucceeded,
      filters,
      classes,
    } = this.props;
    return (
      <Layout>
        <TabNavigation
          items={[
            {
              text: 'Custom Reports',
              href: '/reports/custom',
            },
            {
              text: 'Claim Reports',
              href: '/reports/claim',
            },
            {
              text: 'Insurance Usage',
              href: '/reports/insurance',
            },
          ]}
        />
        {(loading > 0) ? (
          <Progress />
        ) : (
          <Fragment>
            <Helmet>
              <title>
                {appTitle} {titleSeparator} {' '}
                {variant === 'create' ? 'Custom Reports' : ''}
                {variant === 'edit' && initialValues ? `Report ${titleSeparator} ${initialValues.Name}` : ''}
                {variant === 'claim' ? 'Claim Reports' : ''}
                {variant === 'insurance' ? 'Insurance Reports' : ''}
              </title>
            </Helmet>
            <ReportsCreateEditForm
              form={form}
              variant={variant}
              filters={filters}
              onReportTemplateSelect={(values) => {
                history.push(`/reports/custom/${values.ID}`);
              }}
              {...variant === 'claim' ? {
                initialValues: {
                  claimDateOfCreationType: 'Date range',
                  'Step Value': 'Week',
                },
              } : {}}
              {...variant === 'edit' || variant === 'create' ? {
                initialValues,
              } : {}}
              onReportGenerate={this.onReportGenerate}
              onSubmitSuccess={(values) => {
                if (variant === 'create' || values.copyAndSaveAsNew) {
                  history.push(`/reports/custom/${values.ID}`);
                }
              }}
            />
          </Fragment>
        )}
        {dirty &&
          <Prompt
            when={dirty && !submitSucceeded}
            message="All the setups will be reset. Are you sure that you want to leave this page?"
          />
        }
      </Layout>
    );
  }
}

ReportCreateEdit.propTypes = {
  form: PropTypes.string,
  variant: PropTypes.oneOf(['create', 'edit', 'claim', 'insurance']),
  initialValues: PropTypes.shape({
    Name: PropTypes.string,
    'Date of Service From': PropTypes.string,
    'Date of Service To': PropTypes.string,
    'Date of Creation From': PropTypes.string,
    'Date of Creation To': PropTypes.string,
    'Workflow State': PropTypes.arrayOf(PropTypes.shape({
      value: PropTypes.number,
      label: PropTypes.string,
    })),
    'Workflow Status': PropTypes.arrayOf(PropTypes.shape({
      value: PropTypes.number,
      label: PropTypes.string,
    })),
    'Report Order Line Type': PropTypes.arrayOf(PropTypes.shape({
      value: PropTypes.string,
      label: PropTypes.string,
    })),
    'HCPC Code': PropTypes.arrayOf(PropTypes.shape({
      ID: PropTypes.number,
      'HCPC S Code': PropTypes.string,
    })),
    'Assigned User': PropTypes.arrayOf(PropTypes.shape({
      ID: PropTypes.number,
      'First Name': PropTypes.string,
      'Last Name': PropTypes.string,
    })),
    Prescriber: PropTypes.arrayOf(PropTypes.shape({
      ID: PropTypes.number,
      'First Name': PropTypes.string,
      'Last Name': PropTypes.string,
    })),
    'Sales Representative': PropTypes.arrayOf(PropTypes.shape({
      ID: PropTypes.number,
      'First Name': PropTypes.string,
      'Last Name': PropTypes.string,
    })),
    'Referral Source': PropTypes.arrayOf(PropTypes.shape({
      ID: PropTypes.number,
      'First Name': PropTypes.string,
      'Last Name': PropTypes.string,
    })),
    'Insurance Info': PropTypes.arrayOf(PropTypes.shape({
      ID: PropTypes.number,
      'Payer Name': PropTypes.string,
    })),
    Patient: PropTypes.arrayOf(PropTypes.shape({
      'Record Number': PropTypes.number,
      'First Name': PropTypes.string,
      'Last Name': PropTypes.string,
    })),
  }),
  filters: PropTypes.shape({
    Name: PropTypes.string,
    'Date of Service From': PropTypes.string,
    'Date of Service To': PropTypes.string,
    'Date of Creation From': PropTypes.string,
    'Date of Creation To': PropTypes.string,
    'Workflow State ID': PropTypes.arrayOf(PropTypes.number),
    'Workflow Status ID': PropTypes.arrayOf(PropTypes.number),
    'Report Order Line Type': PropTypes.arrayOf(PropTypes.string),
  }),
  loading: PropTypes.number.isRequired,
  dirty: PropTypes.bool.isRequired,
  submitSucceeded: PropTypes.bool.isRequired,
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
  }).isRequired,
  location: PropTypes.shape({
    pathname: PropTypes.string.isRequired,
    state: PropTypes.shape({
      justCreated: PropTypes.bool,
    }),
  }).isRequired,
  match: PropTypes.shape({
    params: PropTypes.shape({
      id: PropTypes.string,
    }).isRequired,
  }).isRequired,
  actions: PropTypes.shape({
    fetchReport: PropTypes.func.isRequired,
    generateReport: PropTypes.func.isRequired,
    generateClaimReport: PropTypes.func.isRequired,
    generateInsuranceReport: PropTypes.func.isRequired,
  }).isRequired,
  classes: PropTypes.shape({
    toolbar: PropTypes.string.isRequired,
  }).isRequired,
};

ReportCreateEdit.defaultProps = {
  form: 'reportCreate',
  variant: 'create',
  initialValues: null,
  filters: {},
};

const mapStateToProps = (store, ownProps) => {
  let initialValues = {
    'Not Rejected': true,
  };
  let reportCreateFormValues = null;
  let reportCreateSyncErors = {};
  if (ownProps.variant === 'edit') {
    const report = store.reports.data.length > 0
      ? store.reports.data.find(item => item.ID === Number(ownProps.match.params.id))
      : null;
    initialValues = report
      ? {
        ID: report.ID,
        Name: report.Name,
        ...report['Default Report Structure'] ? {
          'Default Report Structure Name': report['Default Report Structure'].Name,
          'Default Report Structure ID': report['Default Report Structure'].ID,
        } : {},
        ...report['Date of Service From']
          ? { 'Date of Service From': report['Date of Service From'] } : {},
        ...report['Date of Service To']
          ? { 'Date of Service To': report['Date of Service To'] } : {},
        ...report['Date of Creation From']
          ? { 'Date of Creation From': report['Date of Creation From'] } : {},
        ...report['Date of Creation To']
          ? { 'Date of Creation To': report['Date of Creation To'] } : {},
        ...report['Workflow State']
          ? { 'Workflow State': report['Workflow State'].map(item => ({
            value: item.ID,
            label: item.Name,
          })) }
          : {},
        ...report['Reimbs Date From']
          ? { 'Reimbs Date From': report['Reimbs Date From'] } : {},
        ...report['Reimbs Date To']
          ? { 'Reimbs Date To': report['Reimbs Date'] } : {},
        ...report['Report State']
          ? { 'Report State': report['Report State'].map(item => ({
            value: item,
            label: item,
          })) }
          : {},
        ...report['Workflow Status']
          ? { 'Workflow Status': report['Workflow Status'].map(item => ({
            value: item.ID,
            label: item.Name,
          })) }
          : {},
        ...report['Report Order Type']
          ? { 'Report Order Line Type': report['Report Order Type'].map(item => ({
            value: item,
            label: item,
          })) }
          : {},
        ...report['HCPC Code']
          ? { 'HCPC Code': report['HCPC Code'].map(item => ({
            value: item.ID,
            label: item['HCPC S Code'],
          })) }
          : {},
        ...report['Assigned User']
          ? { 'Assigned User': report['Assigned User'].map(item => ({
            value: item.ID,
            label: `${item['First Name']} ${item['Last Name']}`,
          })) }
          : {},
        ...report.Prescriber
          ? { Prescriber: report.Prescriber.map(item => ({
            value: item.ID,
            label: `${item['First Name']} ${item['Last Name']}`,
          })) }
          : {},
        ...report['Sales Representative']
          ? { 'Sales Representative': report['Sales Representative'].map(item => ({
            value: item.ID,
            label: `${item['First Name']} ${item['Last Name']}`,
          })) }
          : {},
        ...report['Referral Source']
          ? { 'Referral Source': report['Referral Source'].map(item => ({
            value: item.ID,
            label: item['Name of source'],
          })) }
          : {},
        ...report['Insurance Info']
          ? { 'Insurance Info': report['Insurance Info'].map(item => ({
            value: item.ID,
            label: item['Payer Name'],
          })) }
          : {},
        ...report.Patient
          ? { Patient: report.Patient.map(item => ({
            value: item['Record Number'],
            label: `${item['First Name']} ${item['Last Name']}`,
          })) }
          : {},
        ...report['Report Order Rejected'] && report['Report Order Rejected'].length === 2
          ? {
            Rejected: true,
            'Not Rejected': true,
          } : {
            'Not Rejected': true,
          },
        ...report['Report Order Rejected'] && report['Report Order Rejected'].length === 1
          ? {
            Rejected: true,
            'Not Rejected': false,
          } : {
            'Not Rejected': true,
          },
        ...report['Check Book Sheet']
          ? { 'Check Book Sheet': report['Check Book Sheet'].map(item => ({
            value: item.ID,
            label: item['Check Number'],
          })) }
          : {},
      } : null;
  }
  reportCreateFormValues = getFormValues(ownProps.form)(store);
  reportCreateSyncErors = getFormSyncErrors(ownProps.form)(store);

  return {
    reports: store.reports.data,
    loading: store.reports.loading,
    ...initialValues ? { initialValues } : {},
    ...reportCreateFormValues ? {
      filters: {
        ...(reportCreateFormValues['Date of Service From']
          && reportCreateFormValues['Date of Service To']
          && !reportCreateSyncErors['Date of Service From']
          && !reportCreateSyncErors['Date of Service To']) ? {
            'Date of Service From':
              moment(reportCreateFormValues['Date of Service From'], dateFormat)
                .format(dateFormat),
            'Date of Service To':
              moment(reportCreateFormValues['Date of Service To'], dateFormat)
                .format(dateFormat),
          } : {},
        ...(reportCreateFormValues['Date of Creation From']
          && reportCreateFormValues['Date of Creation To']
          && !reportCreateSyncErors['Date of Creation From']
          && !reportCreateSyncErors['Date of Creation To']) ? {
            'Date of Creation From':
              moment(reportCreateFormValues['Date of Creation From'], dateFormat)
                .format(dateFormat),
            'Date of Creation To':
              moment(reportCreateFormValues['Date of Creation To'], dateFormat)
                .format(dateFormat),
          } : {},

        ...(reportCreateFormValues['Reimbs Date From']
          && reportCreateFormValues['Reimbs Date To']
          && !reportCreateSyncErors['Reimbs Date From']
          && !reportCreateSyncErors['Reimbs Date To']) ? {
            'Reimbs Date From':
              moment(reportCreateFormValues['Reimbs Date From'], dateFormat)
                .format(dateFormat),
            'Reimbs Date To':
              moment(reportCreateFormValues['Reimbs Date To'], dateFormat)
                .format(dateFormat),
          } : {},

        ...(reportCreateFormValues.claimDateOfCreationType === 'Date range'
          && reportCreateFormValues['Claim Date of Creation From']
          && reportCreateFormValues['Claim Date of Creation To']
          && !reportCreateSyncErors['Claim Date of Creation From']
          && !reportCreateSyncErors['Claim Date of Creation To']) ? {
            'Claim Date of Creation From':
              moment(reportCreateFormValues['Claim Date of Creation From'], dateFormat)
                .format(dateFormat),
            'Claim Date of Creation To':
              moment(reportCreateFormValues['Claim Date of Creation To'], dateFormat)
                .format(dateFormat),
          } : {},
        ...(reportCreateFormValues.claimDateOfCreationType === 'In last'
          && reportCreateFormValues['Step Number']
          && reportCreateFormValues['Step Value']
          && !reportCreateSyncErors['Step Number']
          && !reportCreateSyncErors['Step Value']) ? {
            'Step Number': reportCreateFormValues['Step Number'],
            'Step Value': reportCreateFormValues['Step Value'],
          } : {},
        ...reportCreateFormValues['Workflow State'] && reportCreateFormValues['Workflow State'].length > 0
          ? { 'Workflow State ID': reportCreateFormValues['Workflow State'].map(item => item.value) } : {},
        ...reportCreateFormValues['Workflow Status'] && reportCreateFormValues['Workflow Status'].length > 0
          ? { 'Workflow Status ID': reportCreateFormValues['Workflow Status'].map(item => item.value) } : {},
        ...reportCreateFormValues['Report Order Line Type'] && reportCreateFormValues['Report Order Line Type'].length > 0
          ? { 'Report Order Line Type': reportCreateFormValues['Report Order Line Type'].map(item => item.value) } : {},
        ...reportCreateFormValues['HCPC Code'] && reportCreateFormValues['HCPC Code'].length > 0
          ? { 'HCPC S Code ID': reportCreateFormValues['HCPC Code'].map(item => item.value) } : {},
        ...reportCreateFormValues['Assigned User'] && reportCreateFormValues['Assigned User'].length > 0
          ? { 'Assigned User ID': reportCreateFormValues['Assigned User'].map(item => item.value) } : {},
        ...reportCreateFormValues.Prescriber && reportCreateFormValues.Prescriber.length > 0
          ? { 'Prescriber ID': reportCreateFormValues.Prescriber.map(item => item.value) } : {},
        ...reportCreateFormValues['Sales Representative'] && reportCreateFormValues['Sales Representative'].length > 0
          ? { 'Sales Representative ID': reportCreateFormValues['Sales Representative'].map(item => item.value) } : {},
        ...reportCreateFormValues['Referral Source'] && reportCreateFormValues['Referral Source'].length > 0
          ? { 'Referral Source ID': reportCreateFormValues['Referral Source'].map(item => item.value) } : {},
        ...reportCreateFormValues['Insurance Info'] && reportCreateFormValues['Insurance Info'].length > 0
          ? { 'Insurance Info ID': reportCreateFormValues['Insurance Info'].map(item => item.value) } : {},
        ...reportCreateFormValues.Patient && reportCreateFormValues.Patient.length > 0
          ? { 'Patient ID': reportCreateFormValues.Patient.map(item => item.value) } : {},
        ...reportCreateFormValues.Rejected && reportCreateFormValues['Not Rejected']
          ? { 'Report Order Line Rejected': [true, false] } : {},
        ...reportCreateFormValues.Rejected && !reportCreateFormValues['Not Rejected']
          ? { 'Report Order Line Rejected': [true] } : {},
        ...reportCreateFormValues['Check Book Sheet'] && reportCreateFormValues['Check Book Sheet'].length > 0
        ? { 'Check Book Sheet ID': reportCreateFormValues['Check Book Sheet'].map(item => item.value) } : {},
        ...reportCreateFormValues['Default Report Structure ID']
        ? { 'Report Structure ID': reportCreateFormValues['Default Report Structure ID'] } : {},
      },
    } : {},
    dirty: isDirty(ownProps.form)(store),
    submitSucceeded: hasSubmitSucceeded(ownProps.form)(store),
  };
};

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators({
    fetchReport,
    generateReport,
    generateClaimReport,
    generateInsuranceReport,
  }, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(
  withStyles(styles)(ReportCreateEdit),
);



// WEBPACK FOOTER //
// ./src/pages/reports/ReportCreateEdit.js